<template>
  <div>
    <div class="d-flex align-center mb-4" style="gap: 8px">
      <h1 class="my-0">
        Overview
      </h1>
      <v-spacer></v-spacer>
      <SelectStorePopover :storeSelectWatcher="onSelectedStores" />
      <PickDatePopover :handler="pickedDate" :timezone="pagePreference.standardTimezone || 'America/Los_Angeles'" />
    </div>
    <v-row v-if="getTimezoneDone">
      <v-col cols="12" md="6">
        <TotalSales
          :dateRange="dateRange"
          :stores="stores"
          :timezone="pagePreference.standardTimezone || 'America/Los_Angeles'"
        />
      </v-col>
      <v-col cols="12" md="6">
        <ConversionRate
          :dateRange="dateRange"
          :stores="stores"
          :timezone="pagePreference.standardTimezone || 'America/Los_Angeles'"
        />
      </v-col>
      <v-col cols="12" md="6">
        <TotalOrders
          :dateRange="dateRange"
          :stores="stores"
          :timezone="pagePreference.standardTimezone || 'America/Los_Angeles'"
        />
      </v-col>
      <v-col cols="12" md="6">
        <AverageOrderValue
          :dateRange="dateRange"
          :stores="stores"
          :timezone="pagePreference.standardTimezone || 'America/Los_Angeles'"
        />
      </v-col>
      <v-col cols="12" md="6">
        <AverageOrderItems
          :dateRange="dateRange"
          :stores="stores"
          :timezone="pagePreference.standardTimezone || 'America/Los_Angeles'"
        />
      </v-col>
      <v-col cols="12" md="6">
        <AbandonedCheckoutsRecovery
          :dateRange="dateRange"
          :stores="stores"
          :timezone="pagePreference.standardTimezone || 'America/Los_Angeles'"
        />
      </v-col>
      <v-col cols="12">
        <TrafficSourceTable
          :dateRange="dateRange"
          :stores="stores"
          :timezone="pagePreference.standardTimezone || 'America/Los_Angeles'"
        />
      </v-col>
      <v-col cols="12">
        <TrafficLocationTable
          :dateRange="dateRange"
          :stores="stores"
          :timezone="pagePreference.standardTimezone || 'America/Los_Angeles'"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import SelectStorePopover from './components/SelectStorePopover';
import PickDatePopover from './components/PickDatePopover';
import TotalSales from './components/TotalSales';
import TotalOrders from './components/TotalOrders';
import ConversionRate from './components/ConversionRate';
import AverageOrderValue from './components/AverageOrderValue';
import AverageOrderItems from './components/AverageOrderItems';
import AbandonedCheckoutsRecovery from './components/AbandonedCheckoutsRecovery';
import TrafficLocationTable from './components/TrafficLocationTable';
import TrafficSourceTable from './components/TrafficSourceTable';

import moment from 'moment';
import STORAGE_NAME from '@/const/storage';
import {
  FETCH_CONVERSION_RATE,
  FETCH_TOTAL_ORDERS,
  FETCH_TOTAL_SALES,
  FETCH_AOV_RATE,
  FETCH_AOI_RATE,
  FETCH_PAGE_PREFERRENCE,
  FETCH_STORES,
} from '@/store/actions.type';

export default {
  components: {
    PickDatePopover,
    SelectStorePopover,
    TotalSales,
    TotalOrders,
    ConversionRate,
    AverageOrderValue,
    AverageOrderItems,
    TrafficLocationTable,
    AbandonedCheckoutsRecovery,
    TrafficSourceTable,
  },
  data() {
    let query = this.$route.query;
    return {
      width: 2,
      autoRefresh: query?.refresh === 'true' || false,
      refreshInterval: false,
      dateRange: {
        from: query?.from_time,
        to: query?.to_time,
      },
      stores: query?.store?.split(',') || [],
      getTimezoneDone: true,
    };
  },
  async beforeMount() {
    if (!this.pagePreference.standardTimezone) {
      this.getTimezoneDone = false;
      await this.$store.dispatch(FETCH_PAGE_PREFERRENCE);
      this.getTimezoneDone = true;
    }
  },
  async created() {
    // let { autoRefresh } = this.loadQueryFromCache();
    if (this.refresh) this.autoRefreshChart();
    await this.$store.dispatch(FETCH_STORES);
  },
  methods: {
    pickedDate(dates) {
      this.dateRange = {
        from: dates.startDate,
        to: dates.endDate,
      };
      let query = this.$route.query;
      this.updateQuery({
        stores: query?.stores,
        from_time: moment(this.dateRange.from).format('YYYY-MM-DD'),
        to_time: moment(this.dateRange.to).format('YYYY-MM-DD'),
        tz: query?.tz,
        refresh: query?.refresh,
      });
      // this.cacheQuery({ startDate: this.dateRange.from, endDate: this.dateRange.to });
    },
    onAutoRefreshChange(autoRefresh) {
      this.refresh = autoRefresh;
      let query = this.$route.query;
      this.updateQuery({
        stores: query?.stores,
        from_time: moment(this.dateRange.from).format('YYYY-MM-DD'),
        to_time: moment(this.dateRange.to).format('YYYY-MM-DD'),
        tz: query?.tz,
        refresh: this.refresh,
      });
      // this.cacheQuery({ autoRefresh: autoRefresh.toString() });
      if (this.refresh) {
        this.autoRefreshChart();
      } else {
        clearInterval(this.refreshInterval);
      }
    },
    onSelectedStores(stores) {
      this.stores = stores;
      let query = this.$route.query;
      this.updateQuery({
        stores: this.stores.join(','),
        from_time: query?.from_time,
        to_time: query?.to_time,
        tz: query?.tz,
        refresh: query?.refresh,
      });
      // this.cacheQuery({ stores: this.stores });
    },
    autoRefreshChart() {
      this.refreshInterval = setInterval(async () => {
        let { stores, startDate, endDate } = this.loadQueryFromCache();
        if (!startDate) startDate = moment().format('YYYY-MM-DD');
        await Promise.all([
          this.$store.dispatch(FETCH_CONVERSION_RATE, {
            fromTime: startDate,
            toTime: endDate,
            stores,
            timezone: this.pagePreference.standardTimezone,
          }),
          this.$store.dispatch(FETCH_TOTAL_ORDERS, {
            fromTime: startDate,
            toTime: endDate,
            stores,
            timezone: this.pagePreference.standardTimezone,
          }),
          this.$store.dispatch(FETCH_TOTAL_SALES, {
            fromTime: startDate,
            toTime: endDate,
            stores,
            timezone: this.pagePreference.standardTimezone,
          }),
          this.$store.dispatch(FETCH_AOV_RATE, {
            fromTime: startDate,
            toTime: endDate,
            stores,
            timezone: this.pagePreference.standardTimezone,
          }),
          this.$store.dispatch(FETCH_AOI_RATE, {
            fromTime: startDate,
            toTime: endDate,
            stores,
            timezone: this.pagePreference.standardTimezone,
          }),
        ]);
      }, 60 * 5 * 1000); // 5 minutes
    },
    // cacheQuery(args) {
    //   let currentStorageStr = localStorage.getItem(STORAGE_NAME.REPORT_SEARCH_QUERY);
    //   let currentStorage = currentStorageStr ? JSON.parse(currentStorageStr) : {};
    //   currentStorage.startDate =
    //     args && args.startDate ? moment(args.startDate).format('YYYY-MM-DD') : currentStorage.startDate;
    //   currentStorage.endDate =
    //     args && args.endDate ? moment(args.endDate).format('YYYY-MM-DD') : currentStorage.endDate;
    //   currentStorage.stores = args && args.stores ? args.stores : currentStorage.stores;
    //   currentStorage.autoRefresh = args && args.autoRefresh ? args.autoRefresh : currentStorage.autoRefresh;
    //   localStorage.removeItem(STORAGE_NAME.REPORT_SEARCH_QUERY);
    //   localStorage.setItem(STORAGE_NAME.REPORT_SEARCH_QUERY, JSON.stringify(currentStorage));
    // },
    loadQueryFromCache() {
      let cacheQuery = localStorage.getItem(STORAGE_NAME.REPORT_SEARCH_QUERY);
      return cacheQuery ? JSON.parse(cacheQuery) : {};
    },
    updateQuery(query) {
      this.$router.push({
        query: query,
      });
    },
  },
  computed: {
    // ...mapGetters(['pagePreference']),
    pagePreference() {
      return this.$store.getters.pagePreference;
    },
  },
  destroyed() {
    // No remove auto refresh
    let currentCacheQuery = this.loadQueryFromCache();
    let newCacheQuery = { autoRefresh: currentCacheQuery?.autoRefresh };
    localStorage.removeItem(STORAGE_NAME.REPORT_SEARCH_QUERY);
    localStorage.setItem(STORAGE_NAME.REPORT_SEARCH_QUERY, JSON.stringify(newCacheQuery));
  },
};
</script>
